<template>
<div>
  <nav-bar></nav-bar>
  <div class="container-fluid pt-16">
  <div class="container pt-16">
    <h2 class="text-center font-28 secondary-text ">
      {{ $getText("HOME_PAGE_SERVICES_LIST_TITLE")}}
    </h2>
    <p class="text-center font-12 pb-3 secondary-text">
      {{ $getText("HOME-PAGE-SERVICES-LIST-DESC")}}
    </p>

    <div class="">
      <div class="row  text-center ">
        <div class="col-12 " v-for="(item,i) in services" :key="i">
          <div class="border rounded Service-height light-bg">
            <div class="">
              <i :class="item.icons " class="fal fa-alarm-clock  font-60  pt-5 secondary-text"></i>
              <h2 class="secondary-text  font-16 mt-3">{{ item.title }}</h2>
              <p class="secondary-text  ">
                {{ item.text }}  </p>

            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
  </div>
<footer-pages></footer-pages>
</div>
</template>

<script>
import NavBar from "@/components/NavBar";

import FooterPages from "@/components/FooterPages";
export default {
  name: "OurServices",

  metaInfo: {
    title: 'ایزیسیس طراحی وب سایت اپلیکیشن موبایل و استارت اپ-خدمات'
  },
  components:{
    FooterPages,
    NavBar
  },
  data: () => ({
    title:"خدمات",

    services:[]
  }),
  mounted() {
    this.$setCssFiles();
    this.services = this.$getServices();


  },
  methods:{
    getImgUrl(pic) {
      return require('../assets/img/' + pic);
    },
  }
}
</script>

<style scoped>

</style>
